import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/account-profile';

type PropsFromCaller = {
  isOpen: boolean;
  onClose: () => void;
};

const CoursesInfoDialog = ({ isOpen, onClose }: PropsFromCaller) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Courses')}</Dialog.HeadingGroup>
      <Dialog.Content>
        <TrackedDiv
          trackClicks={false}
          requireFullyVisible={false}
          withVisibilityTracking
          trackingName="courses_info_dialog"
        >
          <Typography2 component="p">
            {_t(
              'These are comprehensive learning modules given by industry experts and top academics, offering learners a thorough understanding of a specific subject area.'
            )}
          </Typography2>
        </TrackedDiv>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          component={TrackedButton}
          requireFullyVisible={false}
          withVisibilityTracking
          trackingName="profile_close_courses_dialog"
          onClick={onClose}
        >
          {_t('Got it')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default CoursesInfoDialog;
